import Modal from "antd/lib/modal/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { signUp } from "../../redux/reducers/slice/auth";

const ConfirmSignUpModal = (props: any) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const handleOk = async (query: any) => {
    await dispatch(await signUp(query, props?.onFailed));

    props.setVisible(false);
  };

  return (
    <Modal
      title={t("title_modal_notification")}
      visible={props.visible}
      onOk={() => handleOk(props.signUpValuesInit)}
      okText={t("btn_confirm")}
      onCancel={() => {
        props.setVisible(false);
      }}
      cancelText={t("btn_change")}>
      <span>
        {i18n
          .t("auth_signup_phone_number")
          .replace(
            "[phone_number]",
            props.signUpValuesInit.phone_number_signup
          )}
      </span>
    </Modal>
  );
};

export default ConfirmSignUpModal;
